import { setTime } from './index';

/**
 * Sets time of a given date
 */
export default function setTimeOfDate(dtTarget, dtTime) {
  return setTime(dtTarget, dtTime.getHours(), dtTime.getMinutes());
}
